import {DocumentStoreApi} from '@/components/document/store';
import {DocumentData} from '@/engine';
import {BATCH_OPERATIONS, BatchUpdate} from '@/types/document/store';

export const clearFieldsByPredicate = (store: DocumentStoreApi, predicate: (key: string) => boolean): void => {
  const staleKeys = Object.keys(store.getState().data).filter(predicate);
  if (staleKeys.length > 0) {
    store.getState().batchUpdate(staleKeys.map<BatchUpdate>(id => ({type: BATCH_OPERATIONS.UNSET, id})));
  }
};

export const batchSetFields = (store: DocumentStoreApi, fields: DocumentData['data']): void => {
  store
    .getState()
    .batchUpdate(Object.entries(fields).map<BatchUpdate>(([id, value]) => ({type: BATCH_OPERATIONS.SET, id, value})));
};
